import _ from 'lodash';
import moment from 'moment';
import { Action, Dispatch } from 'redux';
import { Search } from '../constants/search';
import { IAppState } from './reducers';
import {
  searchAssetAccessLogs,
  AssetAccessLogKey,
  IAssetAccessLogHit,
  ILogSearchParams,
} from '../api/vault/searchEngine';
import { AccessLogActionTypes } from './assetPublishes';

export enum ActionType {
  Toggle = 'AssetAccess.Toggle',
  StartQuery = 'AssetAccess.StartQuery',
  StopQuery = 'AssetAccess.StopQuery',
  LoadLogs = 'AssetAccess.LoadLogs',
  ClearLogs = 'AssetAccess.ClearLogs',
  Reset = 'AssetAccess.Reset',
}

export interface IState {
  isOpen: boolean;
  isQuerying: boolean;
  logs: Array<IAssetAccessLogHit>;
}

export interface IAssetAccessAction extends Action<ActionType> {
  payload?: any;
}

const INITIAL_STATE: IState = {
  isOpen: false,
  isQuerying: false,
  logs: [],
};

export default (state: IState = INITIAL_STATE, action: IAssetAccessAction) => {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.StartQuery:
      return {
        ...state,
        isQuerying: true,
      };
    case ActionType.StopQuery:
      return {
        ...state,
        isQuerying: false,
      };
    case ActionType.LoadLogs:
      return {
        ...state,
        logs: action.payload.logs,
      };
    case ActionType.ClearLogs:
      return {
        ...state,
        logs: [],
      };
    case ActionType.Reset:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export const toggleAssetAccess = () => ({
  type: ActionType.Toggle,
});

export const clearLogs = () => ({
  type: ActionType.ClearLogs,
});

export const resetAssetAccess = () => ({
  type: ActionType.Reset,
});

export const queryAssetDownloadLogs = (assetId: string, toggleOnComplete: boolean = false) => async (
  dispatch: Dispatch<IAssetAccessAction>,
  getState: () => IAppState,
) => {
  dispatch({
    type: ActionType.StartQuery,
  });

  const searchParams: ILogSearchParams = {
    size: Search.DEFAULT_DOWNLOADS_RESULTS_LIMIT_SIZE,
    page: Search.DEFAULT_PAGE,
    queryString: '',
    filters: [
      [AssetAccessLogKey.AssetId, assetId],
      [AssetAccessLogKey.ActionType, [AccessLogActionTypes.Download, AccessLogActionTypes.ExchangeDownload]],
    ],
  };

  try {
    const response = await searchAssetAccessLogs(searchParams);
    const { data: { data: { hits: { hits } } } } = response;

    const logs = _.orderBy<IAssetAccessLogHit>(hits, (hit) => [moment(hit._source.actionDate).unix()], 'desc');

    dispatch({
      payload: {
        logs,
      },
      type: ActionType.LoadLogs,
    });
  } catch (e) {
    console.error(`[QA] Error occurred while querying for asset "${assetId}" logs`, e.toString());
  }

  dispatch({
    type: ActionType.StopQuery,
  });

  if (toggleOnComplete) {
    dispatch({
      type: ActionType.Toggle,
    });
  }
};
